import Table from '../../../../atoms/display/Table'
import TableRow from '../../../../atoms/display/TableRow'
import TableCell from '../../../../atoms/display/TableCell'
import Button from '../../../../atoms/inputs/Button'
import { FlexColumn, FlexRow } from '../../../../atoms/layout/Flex'
import Label from '../../../../atoms/display/Label'
import { VisitorRegistrationFormWorker } from '../../../../../types/Company'
import {
  useVisitorRegistrationFormWorkerDeleteDialog,
  useVisitorRegistrationFormWorkerEditDialog,
} from '../../../../../hooks/useDialog'

type Props = {
  workers: VisitorRegistrationFormWorker[]
}

export default function VisitorRegistrationWorkerTable(props: Props) {
  const { workers } = props
  const editDialog = useVisitorRegistrationFormWorkerEditDialog()
  const deleteDialog = useVisitorRegistrationFormWorkerDeleteDialog()

  return (
    <Table
      header={
        <TableRow>
          <TableCell header size="xs" />
          <TableCell header size="xs">
            氏名
          </TableCell>
          <TableCell header>住所</TableCell>
          <TableCell header size="sm2">
            電話番号
          </TableCell>
        </TableRow>
      }
    >
      {workers.map((worker) => (
        <TableRow>
          <TableCell size="xs" align="center">
            <FlexColumn>
              <Button size="sm" height="small" onClick={() => editDialog.open(worker)}>
                編集
              </Button>
              <Button size="sm" height="small" color="caution" onClick={() => deleteDialog.open(worker)}>
                削除
              </Button>
            </FlexColumn>
          </TableCell>
          <TableCell size="xs">
            <FlexColumn space={0}>
              <Label text={worker.kana} variant="caption" />
              <Label text={worker.name} />
            </FlexColumn>
          </TableCell>
          <TableCell>
            <FlexColumn space={0}>
              <FlexRow space={0}>
                <Label text="〒" variant="caption" />
                <Label text={worker.zipCode} variant="caption" />
              </FlexRow>
              <Label text={worker.address} />
            </FlexColumn>
          </TableCell>
          <TableCell size="sm2" align="center">
            <Label text={worker.phoneNumber} />
          </TableCell>
        </TableRow>
      ))}
    </Table>
  )
}
